<template>
  <div
    class="sticky top-0 z-50 flex items-center justify-between w-screen gap-4 px-6 h-15 bg-pure-white"
  >
    <BlBreadcrumbs v-if="currentUser.id" :breadcrumbs="breadcrumbs" />
    <div v-else></div>

    <div
      v-if="report.status === 'unpublished'"
      class="flex items-center flex-shrink-0 gap-4"
    >
      <div
        class="flex items-center flex-shrink-0 h-6 gap-2 px-2 rounded-full bg-success-100"
      >
        <BlIcon
          icon="update"
          color="success"
          class="w-4 h-4"
          :class="{ 'animate-spin': saving }"
        />
        <BlTextBody2 v-if="saving" class="text-success" text="Saving changes" />
        <BlTextBody2 v-else class="text-success" text="All changes saved" />
      </div>
      <div
        class="flex px-1 py-1 bg-slate-400"
        :style="{ borderRadius: '8px', height: '2.375rem' }"
      >
        <div
          v-for="opt in modeOptions"
          :key="opt.value"
          class="flex items-center justify-center flex-shrink-0 h-full transition-all duration-300 rounded cursor-pointer w-30"
          :class="mode === opt.value ? 'bg-pure-white' : 'bg-slate-400'"
          @click="$emit('change-mode', opt.value)"
        >
          <BlTextSubtitle3 :text="opt.label" />
        </div>
      </div>
      <BlInputButton label="Publish report" @clicked="publishOpened = true" />
    </div>

    <div
      v-if="report.status === 'published'"
      class="flex items-center gap-2 truncate"
    >
      <div v-if="report.user" class="truncate">
        <BlTextBody3 text="Published on" />
        <BlTextBody3
          :text="
            displayDate({ date: report.published_at || report.updated_at })
          "
        />
        <BlTextBody3 text="by" />
        <BlTextBody3 v-if="!report.user" text="Deleted user" class="italic" />
        <BlTextBody3 v-else :text="report.user.name" />
      </div>
      <div v-else>
        <BlTextBody3 text="Published on " />
        <BlTextBody3
          :text="
            displayDate({ date: report.published_at || report.updated_at })
          "
        />
      </div>
      <BlChip chip="published" dense />
    </div>

    <BlBackdrop
      v-if="publishOpened"
      title="Confirm report publishing"
      label="Publish"
      description="By publishing this report, you will no longer be able to make changes. Please double-check your report before proceeding."
      empty
      :submitLoading="publishLoading"
      @backdrop-close="publishOpened = false"
      @backdrop-action="onPublish"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { displayDate } from "@/plugins/helper.js";

import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlTextBody3 from "../BlTextBody3.vue";
import BlInputButton from "../BlInputButton.vue";
import BlBreadcrumbs from "../BlBreadcrumbs.vue";
import BlIcon from "../BlIcon.vue";
import BlChip from "../BlChip.vue";
import BlBackdrop from "../BlBackdrop.vue";

export default {
  name: "ReportHeader",
  components: {
    BlTextSubtitle3,
    BlTextBody2,
    BlTextBody3,
    BlInputButton,
    BlBreadcrumbs,
    BlIcon,
    BlChip,
    BlBackdrop
  },
  props: {
    mode: { type: String }, // edit | preview
    saving: { type: Boolean, default: false }
    // @change-mode(val)
  },
  data() {
    return {
      publishOpened: false,
      publishLoading: false,
      modeOptions: [
        { value: "edit", label: "Edit mode" },
        { value: "preview", label: "Preview mode" }
      ]
    };
  },
  computed: {
    ...mapGetters(["currentUser", "report"]),
    breadcrumbs() {
      return [
        {
          label: "Reports",
          target: `/clients/${this.report.client_id}/report`
        },
        { label: this.report.name, target: "?#", truncate: true }
      ];
    }
  },
  methods: {
    ...mapActions(["publishReport"]),
    displayDate,
    async onPublish() {
      const data = {
        slug: this.report.slug,
        report: { status: "published" }
      };
      this.publishLoading = true;
      const { success } = await this.publishReport(data);
      this.publishOpened = false;
      if (!success) return;
      this.$router.push({
        name: "ParentReport",
        params: { slug: this.report.slug }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/reports/ReportHeader.vue